export const experienceData = [
    {
        id: 1,
        company: 'Nanotechx',
        jobtitle: 'Penetration Tester & Cyber Security Consultant',
        startYear: '2022',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Synack',
        jobtitle: 'Bounty Hunter',
        startYear: '2021',
        endYear: 'Present'
    },
    // {
    //     id: 3,
    //     company: 'Wonka Industries',
    //     jobtitle: 'Marketing',
    //     startYear: '2020',
    //     endYear: 'Present'
    // },
]